<template>
<div id="about" class="relative bg-gradient-to-br from-gray-900 via-gray-800 to-black overflow-hidden">
  <!-- Background pattern -->
  <div class="absolute inset-0 opacity-10">
    <div class="absolute inset-0" style="background-image: url('data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'0.1\'%3E%3Ccircle cx=\'30\' cy=\'30\' r=\'2\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E');"></div>
  </div>

  <div class="relative max-w-7xl mx-auto py-24 px-4 sm:py-32 sm:px-6 lg:px-8">
    <div class="lg:grid lg:grid-cols-12 lg:gap-8">
      <div class="sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left">
        <div class="relative">
          <!-- Decorative element -->
          <div class="absolute -top-4 -left-4 w-8 h-8 bg-gradient-to-r from-red-600 to-red-700 rounded-full opacity-75"></div>
          
          <h1 class="text-4xl font-extrabold tracking-tight text-white sm:text-5xl md:text-6xl">
            <span class="block">Dott. Daniele Ciceri</span>
            <span class="block text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-red-600">Personal Trainer</span>
          </h1>
          
          <p class="mt-6 text-xl text-gray-300 leading-relaxed">
            Chinesiologo e Preparatore Atletico con oltre 8 anni di esperienza. Specializzato in allenamento personalizzato, 
            nutrizione sportiva e preparazione atletica. La mia missione è trasformare i tuoi obiettivi in risultati concreti 
            attraverso programmi scientifici e supporto costante.
          </p>
          
          <!-- Qualifications section -->
          <div class="mt-8">
            <h3 class="text-lg font-semibold text-white mb-4">Qualifiche e Titoli</h3>
            <div class="space-y-2">
              <div class="flex items-center text-gray-300">
                <svg class="h-4 w-4 text-red-500 mr-3 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                </svg>
                <span class="text-sm">Dottore in Scienze Motorie - Università Cattolica</span>
              </div>
              <div class="flex items-center text-gray-300">
                <svg class="h-4 w-4 text-red-500 mr-3 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                </svg>
                <span class="text-sm">Dottore in Nutrizione Umana - San Raffaele Roma</span>
              </div>
              <div class="flex items-center text-gray-300">
                <svg class="h-4 w-4 text-red-500 mr-3 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                </svg>
                <span class="text-sm">Master Nutrizione Sportiva - Scuola Sanis</span>
              </div>
              <div class="flex items-center text-gray-300">
                <svg class="h-4 w-4 text-red-500 mr-3 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                </svg>
                <span class="text-sm">Master Nutrizione Sportiva - Barça Innovation Hub</span>
              </div>
            </div>
            
            <!-- Professional Registry Link -->
            <div class="mt-6 pt-4 border-t border-gray-700">
              <a href="https://www.scienzemotorie.it/albo/daniele-ciceri" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 class="inline-flex items-center text-sm text-gray-300 hover:text-white transition-colors duration-200">
                <svg class="h-4 w-4 text-red-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                </svg>
                Verificato nell'Albo Chinesiologi Scienze Motorie
                <svg class="h-3 w-3 ml-1" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd" />
                </svg>
              </a>
            </div>
          </div>
          
          <!-- Stats section -->
          <div class="mt-8 grid grid-cols-3 gap-4 sm:gap-8">
            <div class="text-center">
              <div class="text-3xl font-bold text-red-500">500+</div>
              <div class="text-sm text-gray-400">Clienti Soddisfatti</div>
            </div>
            <div class="text-center">
              <div class="text-3xl font-bold text-red-500">8+</div>
              <div class="text-sm text-gray-400">Anni Esperienza</div>
            </div>
            <div class="text-center">
              <div class="text-3xl font-bold text-red-500">24/7</div>
              <div class="text-sm text-gray-400">Supporto</div>
            </div>
          </div>

          <!-- CTA Buttons -->
          <div class="mt-10 flex flex-col sm:flex-row gap-4">
            <a href="https://calendly.com/danieleciceri/30min?back=1&month=2022-03" target="_blank" rel="noopener noreferrer" 
               class="inline-flex items-center justify-center px-8 py-4 border border-transparent text-base font-medium rounded-xl text-white bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transform transition-all duration-200 hover:scale-105 shadow-lg hover:shadow-xl">
              <svg class="mr-2 h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.293l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 001.414 1.414L9 9.414V13a1 1 0 102 0V9.414l1.293 1.293a1 1 0 001.414-1.414z" clip-rule="evenodd" />
              </svg>
              Inizia Ora
            </a>
            <a href="#services" class="inline-flex items-center justify-center px-8 py-4 border-2 border-white text-base font-medium rounded-xl text-white hover:bg-white hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-white transform transition-all duration-200 hover:scale-105">
              Scopri i Servizi
              <svg class="ml-2 h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd" />
              </svg>
            </a>
          </div>
        </div>
      </div>
      
      <div class="mt-12 relative sm:max-w-lg sm:mx-auto lg:mt-0 lg:max-w-none lg:mx-0 lg:col-span-6 lg:flex lg:items-center">
        <div class="relative mx-auto w-full rounded-lg shadow-lg lg:max-w-md">
          <!-- Image container with enhanced styling -->
          <div class="relative overflow-hidden rounded-2xl shadow-2xl">
            <img class="w-full h-96 object-cover transform hover:scale-105 transition-transform duration-700" 
                 src="../assets/daniele_ciceri.jpeg" 
                 alt="Daniele Ciceri - Personal Trainer">
            
            <!-- Overlay gradient -->
            <div class="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
            
            <!-- Floating elements -->
            <div class="absolute top-4 right-4 bg-white/10 backdrop-blur-sm rounded-full p-3">
              <svg class="h-6 w-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd" />
              </svg>
            </div>
            

          </div>
          
          <!-- Floating cards -->
          <div class="absolute -top-4 -left-4 bg-white rounded-lg shadow-xl p-4 transform rotate-3 hover:rotate-0 transition-transform duration-300">
            <div class="flex items-center">
              <div class="w-3 h-3 bg-green-500 rounded-full mr-2"></div>
              <span class="text-sm font-medium text-gray-900">Online</span>
            </div>
            <p class="text-xs text-gray-600 mt-1">Disponibile</p>
          </div>
          
          <div class="absolute -bottom-4 -right-4 bg-white rounded-lg shadow-xl p-4 transform -rotate-3 hover:rotate-0 transition-transform duration-300">
            <div class="text-center">
              <div class="text-2xl font-bold text-red-600">5.0</div>
              <div class="flex justify-center text-yellow-400 text-sm">
                ★★★★★
              </div>
              <p class="text-xs text-gray-600">Rating</p>
              <a href="https://www.miodottore.it/daniele-ciceri-2/chinesiologo/como#profile-reviews" 
                 target="_blank" 
                 rel="noopener noreferrer" 
                 class="text-xs text-blue-600 hover:text-blue-800 underline mt-1 block">
                su MioDottore.it
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Bottom wave decoration -->
  <div class="absolute bottom-0 left-0 right-0">
    <svg class="w-full h-16 text-white" viewBox="0 0 1200 120" preserveAspectRatio="none">
      <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" opacity=".25" fill="currentColor"></path>
      <path d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z" opacity=".5" fill="currentColor"></path>
      <path d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z" fill="currentColor"></path>
    </svg>
  </div>
</div>
</template>

<script>
export default {
  name: "CtaSection",
};
</script>
